const provinces = require("@doncicuto/es-provinces").default;
const municipalities = require("@doncicuto/es-municipalities").default;
const codigosPostales = require("../assets/cp/codigosPostales.json");
const indiceInverso = require("../assets/cp/indiceInverso.json");

export const getProvincias = () => provinces.map((p) => p.name);

export const getMunicipios = (provinciaId) => {
    if (!provinciaId || !provinciaId[0]) return [];
    return municipalities
        .filter((m) => m.provCode === provinciaId[0].code)
        .map((m) => ({
            ...m,
            name: m.name,
            value: m.name,
        }));
};

export const buscarDireccionPorCP = (codigoPostal) => {
    if (!codigoPostal || String(codigoPostal).length !== 5) return null;
    const cpNormalizado = String(codigoPostal).padStart(5, '0');
    const datosCP = codigosPostales[cpNormalizado];

    if (datosCP) {
        const { provincia, poblaciones } = datosCP;
        const provinciaEncontrada = provinces.find(
            (p) => p.name.toLowerCase() === provincia.toLowerCase()
        );

        if (provinciaEncontrada) {
            const poblacionPrincipal = poblaciones.length > 0 ? poblaciones[0] : '';
            return {
                provincia: provinciaEncontrada.name,
                poblacion: poblacionPrincipal,
                provinciaId: [provinciaEncontrada],
            };
        }
    }
    return null;
};

export const buscarCPPorPoblacion = (provincia, poblacion) => {
    if (!provincia || !poblacion) return null;
    const clave = `${provincia}|${poblacion}`;
    const codigosPostalesEncontrados = indiceInverso[clave];

    if (codigosPostalesEncontrados && codigosPostalesEncontrados.length > 0) {
        return codigosPostalesEncontrados[0];
    }
    return null;
};

export const buscarProvinciaPorNombre = (provinciaName) => {
    if (!provinciaName) return [];
    return provinces.filter((p) => p.name === provinciaName);
}
